var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"WelcomePage"},[_c('h1',[_vm._v("V你50自己捡")]),_c('div',{on:{"click":function($event){return _vm.play()}}},[_vm._v("拿50")]),_c('div',[_vm._v("设置")]),_c('div',[_vm._v("关于")])])}
var staticRenderFns = []

export { render, staticRenderFns }